import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
// import Vue from 'vue'
import { nextTick } from 'vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/universalcity',
    name: 'universalcity',
    meta: { layout: 'default', title: 'Universal City' },
    component: () => import('../views/UniversalCity.vue')
  },
  {
    path: '/chelsea-eagles',
    name: 'chelsea-eagles',
    meta: { layout: 'default', title: 'Chelsea Eagles' },
    component: () => import('../views/ChelseaEagles.vue')
  },
  {
    path: '/Bravo',
    name: 'Bravo',
    meta: { layout: 'default', title: 'Bravo' },
    component: () => import('../views/BravoPage.vue')
  },
  {
    path: '/driver',
    name: 'driver',
    meta: { layout: 'default', title: 'DriverPage' },
    component: () => import('../views/DriverPage.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    meta: { layout: 'default', title: 'admin' },
    component: () => import('../views/AdminPage.vue')
  },
  {
    path: '/belwood',
    name: 'Belwood',
    meta: { layout: 'default', title: 'Belwood' },
    component: () => import('../views/BelwoodPage.vue')
  },
  {
    path: '/aberdeen',
    name: 'aberdeen',
    meta: { layout: 'default', title: 'aberdeen' },
    component: () => import('../views/AberdeenPage.vue')
  },
  {
    path: '/wilde',
    name: 'Wilde',
    meta: { layout: 'default', title: 'Wilde' },
    component: () => import('../views/WildePage.vue')
  },
  {
    path: '/stackable',
    name: 'Stackable',
    meta: { layout: 'default', title: 'Stackable' },
    component: () => import('../views/StackPage.vue')
  },
  {
    path: '/SaleFish',
    name: 'SaleFish',
    meta: { layout: 'default', title: 'SaleFish' },
    component: () => import('../views/SaleFishPage.vue')
  },
  // BerkeleyPage
  {
    path: '/berkeley',
    name: 'Berkeley',
    meta: { layout: 'default', title: 'Berkeley' },
    component: () => import('../views/BerkeleyPage.vue')
  },
  // viceroy
  {
    path: '/viceroy',
    name: 'Viceroy',
    meta: { layout: 'default', title: 'Viceroy' },
    component: () => import('../views/ViceroyPage.vue')
  },
  // 1 Marlborough
  {
    path: '/marlborough',
    name: 'Marlborough',
    meta: { layout: 'default', title: '1 Marlborough' },
    component: () => import('../views/MarlboroughPage.vue')
  },
    // Kempinski
    {
      path: '/kempinski',
      name: 'Kempinski',
      meta: { layout: 'default', title: 'Kempinski' },
      component: () => import('../views/KempinskiPage.vue')
    },
  // Bedford
  {
    path: '/bedford',
    name: 'Bedford',
    meta: { layout: 'default', title: 'Bedford' },
    component: () => import('../views/BedfordPage.vue')
  },
  // valley
  {
    path: '/valley',
    name: 'Valley',
    meta: { layout: 'default', title: 'Valley' },
    component: () => import('../views/ValleyPage.vue')
  },
  {
    path: '/gardenhouse',
    name: 'GardenHouse',
    meta: { layout: 'default', title: 'GardenHouse' },
    component: () => import('../views/GardenHouse.vue')
  },
  {
    path: '/the-aston',
    name: 'TheAston',
    meta: { layout: 'default', title: 'TheAston' },
    component: () => import('../views/TheAston.vue')
  },
  {
    path: '/the-aston-v2',
    name: 'TheAstonV2',
    meta: { layout: 'default', title: 'TheAston' },
    component: () => import('../views/TheAston2.vue')
  },
  // House of Wellness Unreal
  {
    path: '/house-of-wellness',
    name: 'HouseOfWellness',
    meta: { layout: 'default', title: 'House of Wellness Unreal' },
    component: () => import('../views/HouseOfWellnessPage.vue')
  },
  // Pixel Stackable
  {
    path: '/pixel-stackable',
    name: 'PixelStackable',
    meta: { layout: 'default', title: 'Pixel Stackable' },
    component: () => import('../views/PixelStackablePage.vue')
  },
  // Anantara
  {
    path: '/anantara',
    name: 'Anantara',
    meta: { layout: 'default', title: 'Anantara' },
    component: () => import('../views/AnantaraPage.vue')
  },
  {
    path: '/test',
    name: 'test',
    meta: { layout: 'default', title: 'test' },
    component: () => import('../views/TestPage.vue')
  },
  // Kingfisher
  {
    path: '/kingfisher',
    name: 'Kingfisher',
    meta: { layout: 'default', title: 'Kingfisher' },
    component: () => import('../views/KingfisherPage.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  nextTick(() => {
    document.title = to.meta.title || 'Page'
  })
})

export default router
